import { FC, JSX } from "react";
import { siteRoutes } from "@/routes/siteRoutes";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Avatar, Box, Flex, Text } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";

const User: FC = (): JSX.Element => {
  const profile = useCurrentUserProfile((s) => s.user);
  const navigate = useNavigate();

  const avatar = profile.avatarURL
    ? profile.avatarURL + "&tr=w-100,h-100,q-70"
    : "";

  return (
    <Box
      onClick={() => navigate(siteRoutes.profile.view.path)}
      style={{ cursor: "pointer" }}
    >
      <Flex gap="3" align="center">
        <Avatar src={avatar} fallback="A" radius="full" size="3" />
        <Box display={{ initial: "none", md: "block" }}>
          <Text as="div" size="2" weight="bold" truncate>
            {profile.firstName} {profile.lastName}
          </Text>
          <Text as="div" size="1" color="gray" truncate>
            {profile.email}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default User;
